<button
  type="button"
  class="downloadable-file-card"
  (click)="onDownload()"
  [attr.aria-label]="'Download ' + (file().name ?? 'file')"
>
  <i [class]="getIconClass()" class="file-icon" aria-hidden="true"></i>
  <span class="file-info">
    <span class="file-name">{{ file().name ?? '—' }}</span>
    @if (getSizeKb() != null) {
      <span class="file-size">({{ getSizeKb() }} kb)</span>
    }
  </span>
  <i class="fas fa-arrow-down file-download-icon" aria-hidden="true"></i>
</button>
